var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "org-scholars-list" },
    [
      _vm._m(0),
      _vm._l(_vm.scholarsData, function (scholar, index) {
        return _c("div", { key: index, staticClass: "expert-item" }, [
          _c("div", { staticClass: "expert-inf" }, [
            _c(
              "div",
              {
                staticStyle: { cursor: "pointer" },
                on: {
                  click: function ($event) {
                    return _vm.goPersonalDetails(scholar.id)
                  },
                },
              },
              [_c("el-avatar", { attrs: { size: 46, src: scholar.avatar } })],
              1
            ),
            _c("div", { staticClass: "name-title" }, [
              _c(
                "h3",
                {
                  staticStyle: {
                    display: "flex",
                    "white-space": "nowrap",
                    "max-width": "230px",
                  },
                },
                [
                  _c(
                    "b",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.goPersonalDetails(scholar.id)
                        },
                      },
                    },
                    [_vm._v(_vm._s(scholar.name))]
                  ),
                  _vm._l(scholar.showTitle, function (title, idx) {
                    return _c(
                      "div",
                      {
                        key: idx,
                        staticClass: "title-item",
                        attrs: { title: title },
                      },
                      [_vm._v(" " + _vm._s(title) + " ")]
                    )
                  }),
                ],
                2
              ),
              _c("p", { staticClass: "ellipsis" }, [
                _vm._v(" " + _vm._s(scholar.org_name) + " "),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "all-font" }, [
            _vm._v(_vm._s(scholar.position || "-")),
          ]),
          _c(
            "div",
            { staticClass: "multiline-overflow" },
            _vm._l(scholar.fields, function (interest, idx) {
              return _c("span", { key: idx }, [
                _vm._v(_vm._s(interest.name) + "；"),
              ])
            }),
            0
          ),
          _c("div", { staticClass: "all-font" }, [
            _vm._v(_vm._s(scholar.innovation_index_l1)),
          ]),
          _c("div", { staticClass: "all-font" }, [
            _vm._v(_vm._s(scholar.publications_count)),
          ]),
        ])
      }),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ul", { staticClass: "expert-list-header" }, [
      _c("li", [_vm._v("专家姓名")]),
      _c("li", [_vm._v("职务")]),
      _c("li", [_vm._v("研究领域")]),
      _c("li", [_vm._v("产业创新指数")]),
      _c("li", [_vm._v("成果数")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }